<template>
	<div class="drawer">
		<el-drawer
		v-if="detail._id"
		size="363px"
		title="修改预约"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">顾客：</span>
						<span class="value">{{detail.user_info.nick_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">手机号：</span>
						<span class="value">{{detail.user_info.user_mobile}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">宠物：</span>
						<span class="value">{{detail.pet_info.nick_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约服务：</span>
						<span class="value">
							<el-cascader
							style="width:200px;"
							v-model="cascader"
							:options="serviceList"
							>
							</el-cascader>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约日期：</span>
						<span class="value">
							<el-date-picker
							style="width:200px;"
							v-model="datetimerange"
							type="date"
							:clearable="false"
							placeholder="选择日期">
							</el-date-picker>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约班次：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="detail.time_info.start_time" placeholder="请选择">
								<el-option
								v-for="item in [{value:'08:00',label:'08:00 - 12:00'},{value:'12:00',label:'12:00 - 21:00'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约状态：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="detail.states" placeholder="请选择">
								<el-option
								v-for="item in [{value:-1,label:'全部'},{value:0,label:'已删除'},{value:1,label:'已预约'},{value:2,label:'预约审核通过'},{value:3,label:'预约完成'},{value:-2,label:'取消预约'},{value:-3,label:'预约审核失败'},{value:-4,label:'预约成功未到'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约医生：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="doctorId" placeholder="请选择" @change="changeDoctor" :clearable="true">
								<el-option v-for="item in doctorList" :key="item._id"
								:label="item.basic_info.nick_name" :value="item._id">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">预约美容师：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="beautyId" placeholder="请选择" @change="changeBeauty" :clearable="true">
								<el-option v-for="item in beautyList" :key="item._id"
								:label="item.basic_info.nick_name" :value="item._id">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<div>
					<el-button style="width:280px;margin:80px 0 0 40px;" type="primary" size="mini" @click="submit('success')">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				detail:{
					user_info:{},
					pet_info:{},
					time_info:{}
				},
				doctorList:[],
				beautyList:[],
				serviceList:[],
				datetimerange:'',
				doctorId:'',
				beautyId:'',
				cascader:[],
				operation_user_id:'',
			}
		},
		props:{
			yuyueId:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getDetail();
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			// 保存修改
			submit(type){
				if(type==='cancel'){
					this.$emit('submit',{type:'close'})
				}else if(type==="success"){
					let service_info = {}
					for(let i=0;i<this.serviceList.length;i++){
						if(this.serviceList[i].name==this.cascader[0]){
							service_info.server_id = this.serviceList[i]._id;
							service_info.name = this.serviceList[i].name;
							service_info.introduce = this.serviceList[i].introduce;
							if(this.serviceList[i].services_list!=undefined){
								for(let a=0;a<this.serviceList[i].services_list.length;a++){
									if(this.serviceList[i].services_list[a].name==this.cascader[1]){
										service_info.server_id = this.serviceList[i].services_list[a]._id;
										service_info.name = this.serviceList[i].services_list[a].name;
										service_info.introduce = this.serviceList[i].services_list[a].introduce;
									}
								}
							}
						}
					}
					if(this.doctorId!=''){
						for(let i=0;i<this.doctorList.length;i++){
							if(this.doctorList[i]._id==this.doctorId){
								service_info.operation_user_id = this.doctorList[i]._id;
								service_info.operation_user_name = this.doctorList[i].basic_info.nick_name;
							}
						}
					}else if(this.beautyId!=''){
						for(let i=0;i<this.beautyList.length;i++){
							if(this.beautyList[i]._id==this.beautyId){
								service_info.operation_user_id = this.beautyList[i]._id;
								service_info.operation_user_name = this.beautyList[i].basic_info.nick_name;
							}
						}
					}else{
						service_info.operation_user_id = '';
						service_info.operation_user_name = '';
					}
					let params = {
						id:this.yuyueId,
						states:this.detail.states,
						service_info:service_info,
						"time_info": {
							"date": (''+this.datetimerange.getTime()).substr(0,10),          // 预约的日期
							"start_time": this.detail.time_info.start_time,    // 预约的开始时间
							"end_time": this.detail.time_info.start_time=='08:00'?'12:00':'21:00'       // 预约结束时间
						}
					}
					this.$http.post('/api/Reservation/Update', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}
			},
			// 获取详情
			getDetail(){
				let params = {
					id: this.yuyueId,
				}
				this.$http.get('/api/Reservation/Detail', params).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
						this.datetimerange = new Date(Number(this.detail.time_info.date)*1000);
						this.getDoctor();
						this.getBeauty();
						this.getService();
					}
				})
			},
			// 改变医生
			changeDoctor(){
				this.beautyId = '';
			},
			// 改变美容师
			changeBeauty(){
				this.doctorId = '';
			},
			// 获取医生
			getDoctor(){
				let params = {
					keyword:'',
					pageIndex:1,
					pageSize:100,
				}
				this.$http.get('/api/Staff/DoctorList', params).then(res => {
					if (res.code == 0) {
						this.doctorList = res.data.data;
						for(let i=0;i<this.doctorList.length;i++){
							if(this.doctorList[i]._id==this.detail.service_info.operation_user_id){
								this.doctorId = this.doctorList[i]._id;
							}
						}
					}
				})
			},
			// 获取美容师
			getBeauty(){
				let params = {
					keyword:'',
					pageIndex:1,
					pageSize:100,
				}
				this.$http.get('/api/Staff/BeautyList', params).then(res => {
					if (res.code == 0) {
						this.beautyList = res.data.data;
						for(let i=0;i<this.beautyList.length;i++){
							if(this.beautyList[i]._id==this.detail.service_info.operation_user_id){
								this.beautyId = this.beautyList[i]._id;
							}
						}
					}
				})
			},
			// 获取预约服务
			getService(){
				this.$http.get('/api/Reservation/ShopService').then(res => {
					if (res.code == 0) {
						this.serviceList = res.data;
						let list = [];
						for(let i=0;i<this.serviceList.services_list.length;i++){
							let obj = this.serviceList.services_list[i];
							obj.label=obj.name;
							obj.value=obj.name;
							if(obj.name==this.detail.service_info.name){
								this.cascader = [obj.name]
							}
							if(this.serviceList.services_list[i].services_list!=null){
								obj.children = [];
								for(let a=0;a<this.serviceList.services_list[i].services_list.length;a++){
									let obj1 = this.serviceList.services_list[i].services_list[a];
									obj1.label=obj1.name;
									obj1.value=obj1.name;
									if(obj1.name==this.detail.service_info.name){
										this.cascader = [obj.name,obj1.name]
									}
									obj.children.push(obj1)
								}
							}
							list.push(obj)
						}
						this.serviceList = list;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:120px;text-align: right;
			}
		}
		
	}
	
</style>
